import React, { Component } from "react";
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import { translate } from "react-i18next"
import i18n from '../components/lang/i18n'

class Imprint extends Component {
    constructor(props) {
      super(props);
      this.i18n = i18n;
      this.showMessage = this.showMessage.bind(this);
      this.handler = this.handler.bind(this)
      this.state = {
        message: "",
        isApp: false,
      };
    }

    handler() {
        this.setState({
          isApp: false,
        })
      }
  
    showMessage(message) {
      this.setState({
          message: message,
      });
    }
  
    render() {
      const { t } = this.props
      return (
        <Layout cl="" handler={this.handler}>
            <Helmet>
                <title>WFOW - {t("im_imprint", "Impressum")}</title>
                <meta name="description" content="Impressum" />
            </Helmet>

            <div id="main" className="">
                <section id="one">
                    <div className="inner">
                        <header className="major">
                            <h1>{t("im_imprint", "Impressum")}</h1>
                        </header>
                        {/* <span className="image main"><img src={pic11} alt="" /></span> */}

                        <h2>WORLD FULL OF WOMEN</h2>

                        <h5>{t("im_team", "Team")}</h5>
                        <ul className="alt">
                            <li>Hila Nawabi</li>
                            <li>Annika Brockmann</li>
                            <li>Julian Schümann</li>
                            <li>Daniel Hösele</li>
                        </ul>

                        <h5>{t("im_contact", "Kontakt")}</h5>
                        <ul className="alt">
                            <li>WhatsApp: +49 163 2221616</li>
                            <li>Mail: <a href="mailto:admin@worldfullofwomen.com">mail@worldfullofwomen.com</a></li>
                            <li>Web: <a href="https://worldfullofwomen.com/">https://worldfullofwomen.com/</a></li>
                            <li>Wittekindstraße 45</li>
                            <li>30449 Hannover</li>
                        </ul>


                        <h2>{t("im_title1", "Haftung für Inhalte")}</h2>
                        <p>
                            {t("im_text1", "Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.")}
                        </p>


                        <h2>{t("im_title2", "Haftung für Links")}</h2>
                        <p>
                            {t("im_text2", "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.")}
                        </p>


                        <h2>{t("im_title3", "Urheberrecht")}</h2>
                        <p>
                            {t("im_text3", "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.")}
                        </p>
                    </div>
                </section>
            </div>
        </Layout>
    )
    }
} 
export default translate("Index")(Imprint)